import React from 'react';
import { useParams } from 'react-router-dom';
import InvitationView from '../components/InvitationView';

/** `/invitations/received/:invitationId` — a personal invite waiting for me. */
export default function ReceivedInvitationPage() {
  const { invitationId = '' } = useParams<{ invitationId: string }>();
  return <InvitationView source={{ kind: 'received', invitationId }} />;
}
